"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupPOD_STATUS_NOT_INITIALIZED = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupPOD_STATUS_NOT_INITIALIZED(builder) {
  builder.validator(validator_id_1.ValidatorID.POD_STATUS_NOT_INITIALIZED).category(categories_1.ValidatorCategory.Compute).subCategory(categories_1.ValidatorSubCategory.Status).title('Stage 3. Pod not initialized').description("During the launch, Pods go through a sequence of execution stages.\nAfter scheduling the Pod on the Node and preparing containers,\nKubernetes will launch init containers.\n\nThis validator detects if at least one of the init containers within\nthis Pod failed to complete successfully.\n").affected('Pod').example("\nkind: Pod\n...\nstatus:\n  conditions:\n    - type: Initialized\n      status: \"False\"\n      lastProbeTime: null\n      lastTransitionTime: 2022-01-01T00:00:00Z    \n").resolution('Check init container logs').externalLink('https://kubernetes.io/docs/concepts/workloads/pods/pod-lifecycle/');
}

exports.setupPOD_STATUS_NOT_INITIALIZED = setupPOD_STATUS_NOT_INITIALIZED;